import { useCallback, useContext } from 'react';
import { LayoutContext } from '..';
import { LayoutActionType } from '../constant';

export default function useRightPanelLayout() {
  const context = useContext(LayoutContext);
  const dispatch = context?.dispatch || (() => {});
  const rightPanelItemKey = context?.layout?.rightPanelItemKey;

  /** Show right panel */
  const show = useCallback(
    /** @param {string} item Right panel item key */
    (item) => {
      dispatch({ type: LayoutActionType.RIGHT_PANEL_SHOW, item });
    },
    [dispatch]
  );

  /** Hide right panel */
  const hide = useCallback(() => {
    dispatch({ type: LayoutActionType.RIGHT_PANEL_HIDE });
  }, [dispatch]);

  return {
    show,
    hide,
    /** @type {string} */
    itemKey: rightPanelItemKey,
    isVisible: !!rightPanelItemKey,
  };
}
